import { useState, useCallback } from 'react';

// Estado inicial del formulario
export const getInitialFormState = (initialData = {}) => ({
    date: new Date().toISOString().split('T')[0],
    workOrderNumber: '',
    unit: '',
    vin: '',
    plates: '',
    model: '',
    engine: '',
    client: '',
    mileage: '',
    driverName: '',
    driverDescription: '',
    diagnosticType: 'Electronico',
    technicalDescription: '',
    additionalObservations: '',
    priority: 'medium',
    ...initialData,
});

// Hook personalizado para el formulario
export const useWorkOrderForm = (initialData = {}) => {
    const [form, setForm] = useState(() => getInitialFormState(initialData));

    const updateForm = useCallback((updates) => {
        setForm((prev) => ({ ...prev, ...updates }));
    }, []);

    const resetForm = useCallback(() => {
        setForm(getInitialFormState());
    }, []);

    return { form, updateForm, resetForm };
};
